import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPaperclip2"><Path fillRule="evenodd" clipRule="evenodd" d="M11.25 5.375C11.25 3.51104 12.761 2 14.625 2C16.489 2 18 3.51104 18 5.375V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V8H7.5V16C7.5 18.4853 9.51472 20.5 12 20.5C14.4853 20.5 16.5 18.4853 16.5 16V5.375C16.5 4.33947 15.6605 3.5 14.625 3.5C13.5895 3.5 12.75 4.33947 12.75 5.375V16H11.25V5.375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperclip2;
